import { useContext } from 'react';

import ShopifyBurstContext from './ShopifyBurstContext';

export default function useShopifyBurstContext() {
  return useContext(ShopifyBurstContext);
}
